export default "__VITE_ASSET__BITwzGcv__ 584w";